import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var IconBox = forwardRef(function (_a, ref) {
    var Icon = _a.icon, _b = _a.position, position = _b === void 0 ? "left" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, children = _a.children, themeKey = _a.themeKey, title = _a.title, props = __rest(_a, ["icon", "position", "size", "children", "themeKey", "title"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(__assign({ variant: "".concat(position, "-").concat(size), size: size, position: position }, props), {
        themeKey: themeKey,
        baseStyle: {
            boxSizing: "border-box",
            display: "inline-block",
            lineHeight: 0,
        },
    });
    return (jsx(Box, __assign({ ref: ref }, forwardProps, { children: Icon ? (jsx(Icon, { focusable: "false", "aria-hidden": "true", title: title })) : (children) })));
});
IconBox.displayName = "IconBox";

export { IconBox };
//# sourceMappingURL=index.js.map
